//angular
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { LoaderService } from 'src/app/_core/services';
import { MetaService } from 'src/app/_core/services/meta.service';
import { RestResponse } from 'src/app/_shared/models';
import { SettingsService } from '../../../_services/api/settings.service';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';

@Component({
  selector: 'new-notifications',
  templateUrl: './new-notifications.component.html',
  styleUrls: ['./new-notifications.component.scss']
})

export class NewNotificationsComponent implements OnInit, OnDestroy {
  collectionOfGlobalSystemEvents: Array<any> = [];
  collectionOfGlobalChannels: Array<any> = [];
  collectionOfCompanyIntegrations: Array<any> = [];
  isGlobalSystemEventsReady: boolean = false;
  isGlobalChannelsReady: boolean = false;
  isCompanyIntegrationsReady: boolean = false;
  form: FormGroup;
  formSubmitted: boolean = false;
  selectedChannelId: string = '';
  companyNotificationInbox: any;
  isNotificationInbox: boolean = false;
  hasCompanyIntegration: boolean = false;
  private subs = new Unsubscriber();

  @Input() _data: any;
  @Input() formData: any;

  @Output() _emitData: EventEmitter<any> = new EventEmitter<any>();
  @Output() _emitDisableButton: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private _iconRegistry: MatIconRegistry,
    private _fb: FormBuilder,
    private _loader: LoaderService,
    private _meta: MetaService,
    private _sanitizer: DomSanitizer,
    private settingsService: SettingsService,
  ) {
    this._iconRegistry.addSvgIcon('ico-close', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-close-01.svg'));
  }

  setUpForm() {
    this.form = this._fb.group({
      systemEventId: ['', [Validators.required]],
      channelId: ['', [Validators.required]],
      oldChannelId: ['',], // used to story only the old channel id
      companyIntegrationId: ['', [Validators.required]],
    });
    
  }

  getDefaultValue(key): any {
    if(this.formData) {
      return this.formData[key];
    } 
    
  }
  getGlobalSystemEventsBySubscriptionChangesSection(notificationSectionKeyName: string) {
    this.subs.addSub = this.settingsService.getGlobalSystemEventsBySubscriptionChangesSection(notificationSectionKeyName).subscribe(
      (res: RestResponse) => {
        this.collectionOfGlobalSystemEvents = <Array<any>>res.data;
        let value = '';
        if(this.formData) {
          value = this.formData['systemEventId'] + '';
        } else {
          // little hack to convert to string -> + ''
          value = this.collectionOfGlobalSystemEvents.find(event => event.status === 'active')?.id ? this.collectionOfGlobalSystemEvents.find(event => event.status === 'active')?.id + '' : '';
        }
        this.form.get('systemEventId').setValue(value);
        this.isGlobalSystemEventsReady = true;
      },
      (err: RestResponse) => {
        this.isGlobalSystemEventsReady = true;
        this._meta.showNotification(err);
      }
    );
  }

  getGlobalChannels() {
    this.subs.addSub = this.settingsService.getGlobalChannels().subscribe(
      (res: RestResponse) => {
        this.collectionOfGlobalChannels = <Array<any>>res.data;
        this.companyNotificationInbox = this.collectionOfGlobalChannels.find(item => (item.keyName == 'companyNotificationInbox'));
        let value = '';
        if(this.formData) {
          value = this.collectionOfGlobalChannels.find(item=>item.keyName == this.formData['channelId'])?.id + '';
        } else {
          // little hack to convert to string -> + ''
          value = this.collectionOfGlobalChannels[0].id + '';
        }
       
        // little hack to convert to string -> + ''
        this.form.get('channelId').setValue(value);
        this.form.get('oldChannelId').setValue(value);
        this.onSelectChannel(value);
        this.isGlobalChannelsReady = true;
      },
      (err: RestResponse) => {
        this.isGlobalChannelsReady = true;
        this._meta.showNotification(err);
      }
    );
  }

  getCompanyIntegrationsByChannelId(channelId: string) {
    this.subs.addSub = this.settingsService.getCompanyIntegrationsByChannelId(channelId).subscribe(
      (res: RestResponse) => {
        this.collectionOfCompanyIntegrations = <Array<any>>res.data;
        if (this.collectionOfCompanyIntegrations.length == 0) {
          this._emitDisableButton.emit(true);
        } else {
          let value = '';
          if(this.formData) {
            value = this.formData['companyIntegrationId'] + ''
          } else {
            // little hack to convert to string -> + ''
            value = this.collectionOfCompanyIntegrations[0].id + ''
          }

          this.form.get('companyIntegrationId').setValue(value);
          this._emitDisableButton.emit(false);
        }
        this.isCompanyIntegrationsReady = true;
      },
      (err: RestResponse) => {
        this.isCompanyIntegrationsReady = true;
        this._meta.showNotification(err);
      }
    );
  }

  onSelectChannel(channelId: string) {
    if (!this.form.get('companyIntegrationId')) {
      this.form.addControl('companyIntegrationId', new FormControl('', [Validators.required]));
    } else {
      this.form.get('companyIntegrationId').reset();
      this.form.get('companyIntegrationId').setValue('');
    }
    this.hasCompanyIntegration = false;
    this.isCompanyIntegrationsReady = false;
    if (Number(channelId) !== this.companyNotificationInbox.id) {
      this.isNotificationInbox = false;
      this.hasCompanyIntegration = true;
      this.getCompanyIntegrationsByChannelId(channelId);
      this.showNotificationOfType('html')

    } else {
      this._emitDisableButton.emit(false);
      this.isNotificationInbox = true;
      this.showNotificationOfType('text')
    }
  }

  showNotificationOfType(type){
    if(this.formData){ // update
      this.collectionOfGlobalChannels = this.collectionOfGlobalChannels.filter(item=>item.type == type)
    }
  }
  ngOnInit(): void {
    this.setUpForm();
    this.getGlobalSystemEventsBySubscriptionChangesSection(this._data.notificationSectionKeyName);
    this.getGlobalChannels();
  }

  setData(): void {
    this.formSubmitted = !this.formSubmitted;

    if (this.isNotificationInbox) {
      this.form.removeControl('companyIntegrationId');
    }

    if (this.form.invalid) {
      this.formSubmitted = !this.formSubmitted;
      this.form.markAllAsTouched();
      this.form.markAsDirty();
      return;
    }

    this._loader.startPageLoader();
    const data: any = {
      bodyParams: this.form.value,
      channel: this.collectionOfGlobalChannels.find(channel => channel.id === Number(this.form.get('channelId').value)),
    };
    this._emitData.emit(data);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
